var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 310.09174 203.5294",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.8449 0 0 2.9076 -1524.9 -966.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m585 332.36h11v70h-11z",
    fill: "#f10002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536 361.36h109v12h-109z",
    fill: "#f10002"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61,-105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m487 437.36 35 25v-25h-35",
    fill: "#092c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 443.36v21h31l-31-21",
    fill: "#092c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 437.36v3l36 24h5l-41-27",
    fill: "#f10002"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1120,-105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m487 437.36 35 25v-25h-35",
    fill: "#092c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 443.36v21h31l-31-21",
    fill: "#092c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 437.36v3l36 24h5l-41-27",
    fill: "#f10002"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 -1 1120 839.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m487 437.36 35 25v-25h-35",
    fill: "#092c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 443.36v21h31l-31-21",
    fill: "#092c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 437.36v3l36 24h5l-41-27",
    fill: "#f10002"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1058,-62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m487 437.36 35 25v-25h-35",
    fill: "#092c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 443.36v21h31l-31-21",
    fill: "#092c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 437.36v3l36 24h5l-41-27",
    fill: "#f10002"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/English.91bc478be4c93fd201092fd365fddc51.svg";
export { ForwardRef as ReactComponent };